import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { InputOption } from 'components/common/MyCustomSelect/components/InputOption/InputOption';

import { Select } from 'components/DesignSystem/Select';
import { createFilterControl } from 'components/DesignSystem/Select/components/FilterControl/FilterControl';
import { LimitedMultiValueContainer } from 'components/DesignSystem/Select/components/LimitedMultiValueContainer/LimitedMultiValueContainer';

interface Props {
    handleOnChange: (value: ISelectOption<string>[]) => void;
    projectList: ISelectOption<string>[];
    selectedProject: ISelectOption<string>[];
}
const FilterControl = createFilterControl({
    icon: <MuiIcon icon={'folder_open'} type={'outlined'} color={'inherit'} />,
    filterName: 'Projects',
});

export const ProjectsFilter = ({ handleOnChange, projectList, selectedProject }: Props) => {
    return (
        <Select<ISelectOption<string>, true>
            id={'report-project-filter'}
            value={selectedProject}
            options={projectList}
            onChange={handleOnChange}
            maxVisibleOptions={2}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isMulti={true}
            placeholder={'All'}
            boldPlaceholder={true}
            components={{
                Control: FilterControl,
                Option: InputOption,
                ValueContainer: LimitedMultiValueContainer,
            }}
        />
    );
};
